import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NOTE_BODY_MAX } from '../../../../../Consts/organization-detail.const';
import { NoteDialogData, NoteDialogResult } from '../../../Interfaces/note-dialog.interface';

@Component({
  selector: 'app-note-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, TranslateModule],
  templateUrl: './note-dialog.component.html',
  styleUrl: './note-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<NoteDialogComponent, NoteDialogResult>>(MatDialogRef);

  readonly data = inject<NoteDialogData>(MAT_DIALOG_DATA);

  readonly bodyMax = NOTE_BODY_MAX;

  readonly formGroup: FormGroup = this._formBuilder.group({
    body: [this.data.body, [Validators.required, Validators.maxLength(NOTE_BODY_MAX)]],
    pinned: [this.data.pinned],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({
      body: String(this.formGroup.value.body).trim(),
      pinned: Boolean(this.formGroup.value.pinned),
    });
  }

  cancel(): void {
    this._dialogRef.close();
  }
}
